import React from 'react';
import Textfield from '../components/inputs/Textfield';
import Button from '../components/inputs/Button';
import queryString from 'query-string';
import reqwest from 'reqwest';

class Passwordreset extends React.Component {
  constructor(props) {
    super(props);
    this._resetPassword = this._resetPassword.bind(this);
    this.state = {
      error: null
    };
  }
  _resetPassword() {
    const urlParams = queryString.parse(window.location.search);
    let token = urlParams.token;
    const userlogin = this._username._input.value;
    const password = this._password._input.value;
    reqwest({
      url: '//booksearch.delbanco.de/life/loginapi.php',
      data: {
        dataset: 'password',
        action: 'reset',
        userlogin: userlogin,
        newpassword: password,
        token
      },
      method: 'get',
      crossOrigin: true,
      success: data => {
        data = JSON.parse(data);
        const errormessage = data[0].errormessage;
        if (errormessage) {
          this.setState({
            error: errormessage
          });
        } else {
          window.location.href = '/logout';
        }
      }
    });
  }
  render() {
    const urlParams = queryString.parse(window.location.search);
    let username = urlParams.benutzer || '';
    return (
      <div className="main-content">
        <div className="Login">
          <h2 className="PageTitle">Reset Password</h2>
          {this.state.error && (
            <div
              style={{ textAlign: 'center', color: 'red' }}
              dangerouslySetInnerHTML={{ __html: this.state.error }}
            />
          )}
          <Textfield
            ref={node => (this._username = node)}
            defaultValue={username}
            placeholder="Username"
          />
          <Textfield
            type="password"
            ref={node => (this._password = node)}
            placeholder="New Password"
          />
          <Button type="primary" onClick={this._resetPassword}>
            Reset Password
          </Button>
        </div>
      </div>
    );
  }
}

export default Passwordreset;



// WEBPACK FOOTER //
// ./src/js/routes/Passwordreset.js